<template>
  <div class="game-mz-coloring-container" :style="getMainImg(startGameConfigClone.mainImage)">
    <div class="game-mz-coloring">
      <mz-mask-in-game
        :key="data.top + data.left + 'mask' + index"
        v-for="(data, index) in startGameConfigClone.staticMaskConfig"
        :item-data="data"
        :mask-data="maskData"
        @change-item-mask="changeItemMask"
        style="z-index: 3"
      ></mz-mask-in-game>
      <mb-audio-in-game
        :key="data.top + data.left + 'audio' + index + 'reset' + resetState"
        :style="{ ...data.cssStyle }"
        v-for="(data, index) in startGameConfigClone.mbStaticAudioItemData"
        :item-data="data"
        :id="data.id"
      ></mb-audio-in-game>
      <div class="box" :style="imageStyle">
        <img
          draggable="false"
          v-if="showTransparentImage"
          class="tr-image"
          @mousedown="clickOnCanvas"
          :src="getImageSrc(startGameConfigClone.image.trImage)"
        />
        <canvas
          ref="canvasImage"
          @mousedown="clickOnCanvas"
          :width="startGameConfigClone.image.width"
          :height="startGameConfigClone.image.height"
        ></canvas>
      </div>
      <palette
        @change-color="
          color = $event;
          startGameConfigClone.audio && startGameConfigClone.audio.click ? audioClick.play() : '';
        "
        :start-game-config="startGameConfigClone.palette"
      ></palette>
    </div>
  </div>
</template>

<script>
import { Howler } from 'howler';
import defaultMixin from '../../mixins/defaultMixin';
import palette from './palette';
import mzMaskInGame from '../../../../MzMask/MzMaskInGame';
import mbAudioInGame from '../../../../MbAudioModal/MbAudioInGame';
import _ from 'lodash';
export default {
  name: 'mz-coloring',
  mixins: [defaultMixin],
  components: { palette, mzMaskInGame, mbAudioInGame },
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      autoCheck: true,
      resetState: false,
      maskData: [],
      isFinished: false,
      gameState: false,
      canIFillAShape: true,
      showTransparentImage: false,
      color: '#ffffff',
      colors: [],
      canvasImage: {},
      canvasImageData: new Uint8ClampedArray(),
      canvasTemplateImageData: new Uint8ClampedArray(),
      canvasMaskData: new Uint8ClampedArray(),
      imageStyle: {},
      audioClick: null,
      audioNegative: null,
      audioPositive: null,
      audioColors: [],
      playOnEnd: false,
      startGameConfigClone: null,
    };
  },
  methods: {
    changeItemMask(value) {
      if (this.maskData.length > 0) {
        this.maskData = value.item;
        this.checkIfLocked();
      }
    },
    checkIfLocked() {
      if (this.maskData.length > 0) {
        if (this.maskData.filter((el) => el.isWrapped === true).length < this.maskData.length) {
          this.$store.commit('LOCK_GAME', false);
        } else {
          this.$store.commit('LOCK_GAME', true);
        }
      }
    },
    shufflePalette(paletteColors) {
      let temp = _.shuffle(Array.from(Array(paletteColors.length), (_, index) => index)),
        paletteColorsClone = _.cloneDeep(paletteColors);
      paletteColorsClone.forEach((e, i, arr) => {
        arr[i].cssStyle = paletteColors[temp[i]].cssStyle;
      });
      return paletteColorsClone;
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
    getMainImg(mainImg) {
      if (mainImg && mainImg.imagePath) {
        return {
          ...{
            backgroundImage: `url('${this.getImageSrc(mainImg.imagePath)}')`,
          },
          ...this.getCustomStyle(mainImg),
        };
      }
      return this.getCustomStyle(mainImg);
    },
    getImageSrc(imageSrc) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${imageSrc}`);
    },
    loadImage(url) {
      return new Promise((resolve, reject) => {
        let cnv = document.createElement('canvas'),
          img = new Image(),
          ctx = cnv.getContext('2d');
        cnv.width = this.startGameConfigClone.image.width;
        cnv.height = this.startGameConfigClone.image.height;
        img.src = this.getImageSrc(url);
        img.addEventListener('load', () => {
          ctx.drawImage(img, 0, 0);
        });
        img.onload = () =>
          resolve(
            ctx.getImageData(0, 0, this.startGameConfigClone.image.width, this.startGameConfigClone.image.height)
          );
        img.onerror = () => reject(console.log('Error loading image'));
      });
    },
    hex2Rgb(hex) {
      return {
        r: (hex >> 16) & 0xff,
        g: (hex >> 8) & 0xff,
        b: hex & 0xff,
      };
    },
    rgb2hex(rgb) {
      return '#' + [rgb.r, rgb.g, rgb.b].map((c) => c.toString(16)).join('');
    },
    clickOnCanvas(event) {
      if (!this.$store.getters.lockGame) {
        let x = event.offsetX,
          y = event.offsetY,
          gray = this.canvasMaskData.data[y * this.startGameConfigClone.image.width * 4 + x * 4 + 1],
          color = {
            r: this.canvasImageData.data[y * this.startGameConfigClone.image.width * 4 + x * 4],
            g: this.canvasImageData.data[y * this.startGameConfigClone.image.width * 4 + x * 4 + 1],
            b: this.canvasImageData.data[y * this.startGameConfigClone.image.width * 4 + x * 4 + 2],
          },
          isCorrect = true;
        this.fillShape(gray, color);
        if (Array.isArray(this.startGameConfigClone.image.colors)) {
          let oneImageColorsIsCorrect = true;
          for (let oneImageColors of this.startGameConfigClone.image.colors) {
            oneImageColorsIsCorrect = true;
            for (let [i, e] of this.colors.entries()) {
              if (e.toLowerCase() != oneImageColors[i + 1].toLowerCase()) {
                oneImageColorsIsCorrect = false;
                break;
              }
            }
            if (oneImageColorsIsCorrect) break;
          }
          if (!oneImageColorsIsCorrect) isCorrect = false;
        } else {
          for (let [i, e] of this.colors.entries()) {
            if (e.toLowerCase() != this.startGameConfigClone.image.colors[i + 1].toLowerCase()) {
              isCorrect = false;
              break;
            }
          }
        }
        this.gameState = isCorrect;
        if (this.isFinished == false && isCorrect == true && this.autoCheck) {
          if (this.playOnEnd) {
            if (this.startGameConfigClone.audio && this.startGameConfigClone.audio.positive) {
              this.audioPositive.play();
            } else {
              if (this.audioColors.length > 0)
                this.audioColors
                  .filter((e) => {
                    return e.id == this.color;
                  })
                  .map((e) => e.audio)[0]
                  .play();
            }
          }
          this.canIFillAShape = false;
          this.$store.dispatch('checkGame');
        }
        this.isFinished = isCorrect;
      }
    },
    fillShape(gray, previousColor) {
      if (this.canIFillAShape) {
        let color = '#000000';
        if (Array.isArray(this.startGameConfigClone.image.colors)) {
          let oneImageColors = {};
          for (oneImageColors of this.startGameConfigClone.image.colors) {
            if (oneImageColors[gray] == '#000000') break;
          }
          color = oneImageColors[gray];
        } else {
          color = this.startGameConfigClone.image.colors[gray];
        }
        if (color != '#000000') {
          this.canIFillAShape = false;
          const { data } = this.canvasMaskData;
          const { data: paintData } = this.canvasImageData;
          let newColor = { r: 255, g: 255, b: 255 };
          if (this.startGameConfigClone.restoreColor && this.rgb2hex(previousColor) == this.color) {
            this.colors[gray - 1] = this.rgb2hex(newColor);
          } else {
            this.colors[gray - 1] = this.color;
            newColor = this.hex2Rgb(parseInt(this.color.slice(1, 7), 16));
          }
          for (let i = 0; i < data.length; i += 4) {
            if (data[i] == gray) {
              paintData[i] = newColor.r;
              paintData[i + 1] = newColor.g;
              paintData[i + 2] = newColor.b;
            }
          }
          this.canvasImage.putImageData(this.canvasImageData, 0, 0);
          if (this.startGameConfigClone.blockWrongColor) {
            if (this.color != this.startGameConfigClone.image.colors[gray]) {
              this.colors[gray - 1] = this.rgb2hex(previousColor);
              if (this.startGameConfigClone.audio && this.startGameConfigClone.audio.negative) {
                this.audioNegative.play();
                setTimeout(() => {
                  for (let i = 0; i < data.length; i += 4) {
                    if (data[i] == gray) {
                      paintData[i] = previousColor.r;
                      paintData[i + 1] = previousColor.g;
                      paintData[i + 2] = previousColor.b;
                    }
                  }
                  this.canvasImage.putImageData(this.canvasImageData, 0, 0);
                  this.canIFillAShape = true;
                }, this.audioNegative.duration() * 1000 + 100);
              } else {
                for (let i = 0; i < data.length; i += 4) {
                  if (data[i] == gray) {
                    paintData[i] = previousColor.r;
                    paintData[i + 1] = previousColor.g;
                    paintData[i + 2] = previousColor.b;
                  }
                }
                this.canvasImage.putImageData(this.canvasImageData, 0, 0);
                this.canIFillAShape = true;
              }
            } else {
              if (this.startGameConfigClone.audio && this.startGameConfigClone.audio.positive) {
                if (!this.playOnEnd) this.audioPositive.play();
              } else {
                if (!this.playOnEnd && this.audioColors.length > 0)
                  this.audioColors
                    .filter((e) => {
                      return e.id == this.color;
                    })
                    .map((e) => e.audio)[0]
                    .play();
              }
              this.canIFillAShape = true;
            }
          } else {
            this.canIFillAShape = true;
          }
        }
      }
    },
    checkGameAction() {
      if (this.isFinished) this.canIFillAShape = false;
      return this.gameState;
    },
    resetGameAction() {
      if (this.startGameConfig[1]) {
        let rnd = 0;
        do {
          rnd = Math.floor(Math.random() * (10 - 0) + 0);
        } while (!this.startGameConfig[rnd]);
        this.startGameConfigClone = _.cloneDeep(this.startGameConfig[rnd]);
      } else {
        this.startGameConfigClone = _.cloneDeep(this.startGameConfig);
      }
      if (this.startGameConfigClone.palette && this.startGameConfigClone.palette.shuffle) {
        this.startGameConfigClone.palette.colors = this.shufflePalette(this.startGameConfigClone.palette.colors);
      }
      if (this.startGameConfigClone.playOnEnd) this.playOnEnd = this.startGameConfigClone.playOnEnd;
      this.setGameAudio();
      this.canvasImage.clearRect(0, 0, this.startGameConfigClone.image.width, this.startGameConfigClone.image.height);
      this.canvasImage.putImageData(this.canvasTemplateImageData, 0, 0);
      this.canvasImageData = this.canvasImage.createImageData(
        this.startGameConfigClone.image.width,
        this.startGameConfigClone.image.height
      );
      this.canvasImageData.data.set(this.canvasTemplateImageData.data);
      this.colors.forEach((e, i) => {
        this.colors[i] = '#ffffff';
      });
      this.colors[0] = '#000000';
      if ('defaultColors' in this.startGameConfigClone.image) {
        this.startGameConfigClone.image.defaultColors.forEach((currentValue, index) => {
          if (currentValue != '') {
            this.colors[index] = currentValue;
          }
        });
      }
      this.color = '#ffffff';
      if ('firstColor' in this.startGameConfigClone.palette) {
        this.color = this.startGameConfigClone.palette.firstColor;
      }
      this.canIFillAShape = true;
      this.gameState = false;
      this.isFinished = false;
      this.playOnEnd = false;
      if (this.startGameConfigClone.playOnEnd) this.playOnEnd = this.startGameConfigClone.playOnEnd;
      if (this.maskData.length > 0) for (let m of this.maskData) m.isWrapped = true;
      this.checkIfLocked();
      this.resetState = !this.resetState;
    },
    giveMeAudioPlease(path) {
      return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
    },
    setGameAudio() {
      this.audioColors = [];
      for (let color of this.startGameConfigClone.palette.colors) {
        if (color.audio) {
          this.audioColors.push({
            id: color.val,
            audio: new Howl({
              src: this.giveMeAudioPlease(color.audio),
              autoplay: false,
              loop: false,
              volume: 0.5,
            }),
          });
        }
      }
      if (this.startGameConfigClone.audio) {
        if (this.startGameConfigClone.audio.positive) {
          this.audioPositive = new Howl({
            src: this.giveMeAudioPlease(this.startGameConfigClone.audio.positive),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfigClone.audio.click) {
          this.audioClick = new Howl({
            src: this.giveMeAudioPlease(this.startGameConfigClone.audio.click),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
        if (this.startGameConfigClone.audio.negative) {
          this.audioNegative = new Howl({
            src: this.giveMeAudioPlease(this.startGameConfigClone.audio.negative),
            autoplay: false,
            loop: false,
            volume: 0.5,
          });
        }
      }
    },
  },
  computed: {
    resetGameSwitch() {
      return this.$store.getters.resetGame;
    },
  },
  watch: {
    resetGameSwitch(newStatus, oldStatus) {
      if (newStatus) {
        this.resetGameAction();
        this.$store.dispatch('resetGame');
      }
    },
  },
  created() {
    if (this.startGameConfig[1]) {
      let rnd = 0;
      do {
        rnd = Math.floor(Math.random() * (10 - 0) + 0);
      } while (!this.startGameConfig[rnd]);
      this.startGameConfigClone = _.cloneDeep(this.startGameConfig[rnd]);
    } else {
      this.startGameConfigClone = _.cloneDeep(this.startGameConfig);
    }
    if (this.startGameConfigClone.palette && this.startGameConfigClone.palette.shuffle) {
      this.startGameConfigClone.palette.colors = this.shufflePalette(this.startGameConfigClone.palette.colors);
    }
    if (this.startGameConfigClone.image.trImage) {
      this.showTransparentImage = true;
    }
    this.loadImage(this.startGameConfigClone.image.srcMask).then((data) => {
      return (this.canvasMaskData = data);
    });
    this.loadImage(this.startGameConfigClone.image.srcImage).then((data) => {
      return (this.canvasImageData = data);
    });
    this.loadImage(this.startGameConfigClone.image.srcImage).then((data) => {
      return (this.canvasTemplateImageData = data);
    });
  },
  beforeMount() {
    this.imageStyle = this.startGameConfigClone.image.cssStyle;
  },
  mounted() {
    if ('autoCheck' in this.startGameConfigClone) this.autoCheck = this.startGameConfigClone.autoCheck;
    if (this.startGameConfigClone.playOnEnd) this.playOnEnd = this.startGameConfigClone.playOnEnd;
    this.setGameAudio();
    this.canvasImage = this.$refs.canvasImage.getContext('2d');
    let image = new Image();
    image.src = this.getImageSrc(this.startGameConfigClone.image.srcImage);
    image.addEventListener('load', () => {
      this.canvasImage.drawImage(image, 0, 0);
    });
    let lengthOfColors = 0;
    if (Array.isArray(this.startGameConfigClone.image.colors)) {
      lengthOfColors = Object.keys(this.startGameConfigClone.image.colors[0]).length;
    } else {
      lengthOfColors = Object.keys(this.startGameConfigClone.image.colors).length;
    }
    this.colors = Array.from(
      {
        length: lengthOfColors,
      },
      () => '#ffffff'
    );
    this.colors[0] = '#000000';
    if ('defaultColors' in this.startGameConfigClone.image) {
      this.startGameConfigClone.image.defaultColors.forEach((currentValue, index) => {
        if (currentValue != '') {
          this.colors[index] = currentValue;
        }
      });
    }
    this.color = '#ffffff';
    if ('firstColor' in this.startGameConfigClone.palette) {
      this.color = this.startGameConfigClone.palette.firstColor;
    }
    if (this.startGameConfigClone?.staticMaskConfig) {
      this.maskData = this.startGameConfigClone.staticMaskConfig.map(({ id }) => ({ id: id, isWrapped: true }));
      if (this.maskData.length > 0) this.$store.commit('LOCK_GAME', true);
    }
  },
  beforeDestroy() {
    this.$store.commit('LOCK_GAME', false);
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
$backgroundWidth: 1920px;
$backgroundHeight: 1080px;
$backgroundOffsetTop: 0;
$backgroundOffsetLeft: 0;
.game-mz-coloring-container {
  height: 100%;
  width: 100%;
}
.game-mz-coloring {
  position: absolute;
  display: flex;
  top: $backgroundOffsetTop;
  left: $backgroundOffsetLeft;
  height: $backgroundHeight;
  width: $backgroundWidth;
  overflow: hidden;
}
.tr-image {
  position: absolute;
}
</style>
